import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PortalService } from '../../../../../services/portal.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  userProfileForm: FormGroup;
  maxDate: Date = new Date();

  constructor(private fb: FormBuilder,private portalService:PortalService, private  router: Router) {}
  ngOnInit() {
    this.userProfileForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      birthdate: ['', Validators.required],
      primaryPhoneTypeId: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      email: [''] 
    });
  }

  onSubmit() {
    const email = localStorage.getItem('email') || '';
    console.log(email);
    this.userProfileForm.patchValue({
      email: email
    });
    if (this.userProfileForm.valid) {
      //this.dialogRef.close();
      console.log(this.userProfileForm.value);
      this.portalService.createPatientProfile(this.userProfileForm.value).subscribe(
        (response:any) => {
          console.log('Profile saved successfully:', response);
          this.router.navigate(['/profile']);
        },
        (error) => {
          console.error('Error saving profile data:', error);
        }
      );
    } else {
      console.error('Form is invalid. Please correct the errors.');
    }
  }

}
